<template lang="pug">
  .container
    .columns
      .column.is-2
        .field
          label.label Km. Actual
            .control.has-icons-left.has-icons-right
              input.input.is-dark(
                type='text', 
                placeholder='00.00',
                v-model="kmActual",
                :disabled="isDisabled"
              )
    .columns(v-show="verNotificacion")
      .column
        .notificacion
          span Debe introducir el kilometraje para el fin del mes.
    .columns
      .column
        a.button.is-black.is-rounded(@click="checkform")
          | Guardar
        | &nbsp
        a.button.is-rounded(@click="cerrarForm")
          | Cancelar
</template>

<script>
  export default {
    name: 'FormCierreMes',
    data() {
      return {
        kmActual: null,
        verNotificacion: false,
        isDisabled: false
      }
    },
    methods: {
      checkform() {
        if (this.kmActual) {
          this.saveForm()
        } else {
          this.verNotificacion = true
        }
      },
      saveForm() {
        this.$emit('saveKmFinal', this.kmActual)
      },
      cerrarForm () {
        this.$emit('saveKmFinal', 'close')
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/FormCierreMes.vue